export default function City({ className, viewBox = '0 0 48 48' }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg className={className} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_9977_35829)">
        <path
          d="M6.40039 22.7386V9.67334C6.40039 9.26084 6.80189 8.93359 7.21439 8.93359H11.6474C12.0599 8.93359 12.4504 9.26084 12.4504 9.67334V22.7386H6.40039Z"
          fill="url(#paint0_radial_9977_35829)"
        />
        <path
          d="M17.5996 38.3992V5.08543C17.5996 4.03364 18.104 3.19922 18.6222 3.19922H24.1909C24.7091 3.19922 25.1996 4.03364 25.1996 5.08543V38.3992H17.5996Z"
          fill="url(#paint1_radial_9977_35829)"
        />
        <path
          d="M7.5 12.8726H8.8915V14.6106H7.5V12.8726ZM9.93375 12.8726H11.3253V14.6106H9.93375V12.8726ZM7.5 10.4141H8.8915V12.1521H7.5V10.4141ZM9.93375 16.6841H11.3253V18.4221H9.93375V16.6841ZM36.65 14.6106H38.0415V16.3486H36.65V14.6106ZM39.0837 14.6106H40.4753V16.3486H39.0837V14.6106ZM39.0837 19.1453H40.4753V20.8833H39.0837V19.1453ZM36.65 17.2176H38.0415V18.9556H36.65V17.2176Z"
          fill="white"
        />
        <path
          d="M26.5664 38.3661V6.31484C26.5664 5.70159 27.1604 5.21484 27.7737 5.21484H34.3572C34.9704 5.21484 35.5507 5.70159 35.5507 6.31484V38.3633H26.5664V38.3661ZM37.2227 38.3661V12.9148C37.2227 12.3016 37.8167 11.8148 38.4299 11.8148H41.6007V38.3633H37.2227V38.3661Z"
          fill="url(#paint2_radial_9977_35829)"
        />
        <path
          d="M27.8496 7.96484H29.3154V9.79909H27.8496V7.96484ZM30.4154 7.96484H31.8811V9.79909H30.4154V7.96484ZM27.8496 10.7148H29.3154V12.5491H27.8496V10.7148ZM32.9839 10.7148H34.4496V12.5491H32.9839V10.7148ZM32.9839 14.5648H34.4496V16.3991H32.9839V14.5648ZM32.9839 17.3148H34.4496V19.1491H32.9839V17.3148Z"
          fill="white"
        />
        <path
          d="M14.1465 38.3931V8.64909C14.1465 7.97259 14.7955 7.43359 15.461 7.43359H22.6302C23.2985 7.43359 23.9282 7.97259 23.9282 8.64909V38.3958H14.1465V38.3931Z"
          fill="url(#paint3_radial_9977_35829)"
        />
        <path
          d="M18.3417 8.85938H19.9394V10.8834H18.3417V8.85938ZM21.1357 8.85938H22.7334V10.8834H21.1357V8.85938ZM15.5449 11.8981H17.1427V13.9221H15.5449V11.8981ZM21.1357 11.8981H22.7334V13.9221H21.1357V11.8981ZM15.5449 17.9619H17.1427V19.9859H15.5449V17.9619ZM18.3417 14.9369H19.9394V16.9609H18.3417V14.9369ZM21.1357 21.0006H22.7334V23.0246H21.1357V21.0006Z"
          fill="white"
        />
        <path
          d="M19.875 38.3939V20.1229C19.875 19.5977 20.3865 19.1797 20.9118 19.1797H26.8242C27.3495 19.1797 27.8472 19.5977 27.8472 20.1229V38.3939H19.875Z"
          fill="#FF5C33"
        />
        <path
          d="M21.25 20.5547H23.175V23.0297H21.25V20.5547ZM24.55 20.5547H26.475V23.0297H24.55V20.5547ZM24.55 24.1297H26.475V26.6047H24.55V24.1297ZM21.25 27.7047H23.175V30.1797H21.25V27.7047ZM24.55 27.7047H26.475V30.1797H24.55V27.7047ZM21.25 31.2797H23.175V33.7547H21.25V31.2797Z"
          fill="white"
        />
        <path
          d="M33.3863 38.3936H27.6113V27.9766H32.2836C32.4284 27.9766 32.5718 28.0051 32.7056 28.0605C32.8394 28.1159 32.9609 28.1972 33.0633 28.2996C33.1657 28.402 33.247 28.5235 33.3024 28.6573C33.3578 28.7911 33.3863 28.9345 33.3863 29.0793V38.3936Z"
          fill="#FF5C33"
        />
        <path
          d="M30.5996 38.3936V15.6016C30.5996 14.8646 31.3174 14.2761 32.0544 14.2761L40.1641 14.2266C40.9011 14.2266 41.5996 14.8123 41.5996 15.5521V38.3936H30.5996Z"
          fill="#FF5C33"
        />
        <path
          d="M35.5504 17.5273H37.2004V19.4523H35.5504V17.5273ZM32.5254 17.5273H34.1754V19.4523H32.5254V17.5273ZM38.5754 20.5523H40.2254V22.4773H38.5754V20.5523ZM35.5504 20.5523H37.2004V22.4773H35.5504V20.5523ZM35.5504 23.5773H37.2004V25.5023H35.5504V23.5773ZM32.5254 23.5773H34.1754V25.5023H32.5254V23.5773ZM38.5754 26.6023H40.2254V28.5273H38.5754V26.6023ZM35.5504 26.6023H37.2004V28.5273H35.5504V26.6023ZM32.5254 26.6023H34.1754V28.5273H32.5254V26.6023ZM35.5504 32.6523H37.2004V34.5773H35.5504V32.6523ZM32.5254 29.6273H34.1754V31.5523H32.5254V29.6273Z"
          fill="white"
        />
        <path
          d="M13.8548 16.2622H10.3266C9.86734 16.2622 9.49609 16.0587 9.49609 15.5994V14.6039C9.49609 14.1447 9.86734 13.7734 10.3266 13.7734H13.8548C14.3141 13.7734 14.6853 14.1447 14.6853 14.6039V15.5994C14.6853 16.0587 14.3141 16.2622 13.8548 16.2622Z"
          fill="#FF5C33"
        />
        <path
          d="M6.40039 38.3882V16.9492C6.40039 16.2122 7.11814 15.6237 7.85514 15.6237L15.9649 15.5742C16.7019 15.5742 17.4004 16.16 17.4004 16.8997V38.3882H6.40039Z"
          fill="#FF5C33"
        />
        <path
          d="M11.3497 17.7042H12.9997V19.6292H11.3497V17.7042ZM14.3747 17.6602H16.0247V19.5852H14.3747V17.6602ZM8.30273 20.6852H9.95273V22.6102H8.30273V20.6852ZM11.3497 20.7292H12.9997V22.6542H11.3497V20.7292ZM11.3497 23.7542H12.9997V25.6792H11.3497V23.7542ZM14.3747 26.7792H16.0247V28.7042H14.3747V26.7792ZM8.32473 26.7792H9.97473V28.7042H8.32473V26.7792ZM14.3747 32.8292H16.0247V34.7542H14.3747V32.8292ZM11.3497 32.8292H12.9997V34.7542H11.3497V32.8292ZM8.32473 29.8042H9.97473V31.7292H8.32473V29.8042Z"
          fill="white"
        />
      </g>
      <ellipse
        opacity="0.7"
        cx="24"
        cy="43.011"
        rx="24"
        ry="3.40948"
        fill="url(#paint4_radial_9977_35829)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_9977_35829"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.42539 19.3564) rotate(-90) scale(10.1405 4.44405)"
        >
          <stop stopColor="#FF5C33" stopOpacity="0.4" />
          <stop offset="1" stopColor="#FF5C33" stopOpacity="0.1" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_9977_35829"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(21.3996 29.7752) rotate(-90) scale(25.8563 5.58261)"
        >
          <stop stopColor="#FF5C33" stopOpacity="0.4" />
          <stop offset="1" stopColor="#FF5C33" stopOpacity="0.1" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_9977_35829"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(34.0835 30.244) rotate(-90) scale(24.3514 11.0435)"
        >
          <stop stopColor="#FF5C33" stopOpacity="0.7" />
          <stop offset="1" stopColor="#FF5C33" stopOpacity="0.2" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_9977_35829"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.0374 30.8101) rotate(-90) scale(22.7435 7.18523)"
        >
          <stop stopColor="#FF5C33" stopOpacity="0.7" />
          <stop offset="1" stopColor="#FF5C33" stopOpacity="0.2" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_9977_35829"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(24 43.011) rotate(90) scale(3.40948 24)"
        >
          <stop stopColor="#D1D1D1" stopOpacity="0.74" />
          <stop offset="0.838555" stopColor="#DBDBDB" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_9977_35829">
          <path
            d="M6.40039 7.19922C6.40039 4.99008 8.19125 3.19922 10.4004 3.19922H37.6004C39.8095 3.19922 41.6004 4.99008 41.6004 7.19922V34.3992C41.6004 36.6084 39.8095 38.3992 37.6004 38.3992H10.4004C8.19125 38.3992 6.40039 36.6084 6.40039 34.3992V7.19922Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
